
import React from 'react'

const ExclamationCircleFilled = ({ className = "", style }) => {
  return (
    <svg
      width="21.000000"
      height="21.000000"
      viewBox="0 0 21 21"
      fill="currentColor"
      className={className}
      style={style}
    >
      <path
        d="M10.5 0C4.70166 0 0 4.70154 0 10.5C0 16.2985 4.70166 21 10.5 21C16.2983 21 21 16.2985 21 10.5C21 4.70154 16.2983 0 10.5 0ZM9.75 5.4375C9.75 5.33435 9.83447 5.25 9.9375 5.25L11.0625 5.25C11.1655 5.25 11.25 5.33435 11.25 5.4375L11.25 11.8125C11.25 11.9156 11.1655 12 11.0625 12L9.9375 12C9.83447 12 9.75 11.9156 9.75 11.8125L9.75 5.4375ZM9.375 14.625C9.375 15.2461 9.87891 15.75 10.5 15.75C11.1211 15.75 11.625 15.2461 11.625 14.625C11.625 14.0039 11.1211 13.5 10.5 13.5C9.87891 13.5 9.375 14.0039 9.375 14.625Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ExclamationCircleFilled;
